import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Layout } from 'antd'
import { Progress } from 'antd'
import { getTaskOverview } from 'api/Overview/overview'
import { getCookie } from 'helper/cookie'
import '../../../styleLess/signature/new-status-styles.scss'

const TaskOverview = styled.div``
const { Content } = Layout
const initalState = {
  data: [],
}
const TaskCircleprogress = (props) => {
  const { project_id } = props
  const [dataOverview, setDataOverview] = useState(initalState.data)

  const [percentDone, setPercentDone] = useState('0')
  const token = getCookie('access_token_admin')

  const getDataOverview = async () => {
    await getTaskOverview({
      project_id: project_id,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          await setDataOverview([])
          return true
        }
        if (status === 200) {
          await setDataOverview(data)
          setPercentDone(data.percent_complete)
        } else {
          setDataOverview([])
          return true
        }
      })
      .catch((error) => {
        setDataOverview([])
        console.error(error)
      })
  }
  useEffect(() => {
    if (token) {
      getDataOverview()
    }
  }, [token])
  return (
    <TaskOverview className="taskcircle-container">
      <h3>Task Overview</h3>
      <div className="OverallContainer">
        <div style={{ position: 'relative', display: 'inline-block' }}>
          {/* SVG Circle สำหรับแสดงสีหลายสี */}
          <svg width="160" height="160" style={{ transform: 'rotate(-90deg)' }}>
            <circle
              cx="80"
              cy="80"
              r="70"
              fill="none"
              stroke="#Efefef"
              strokeWidth="18"
            />
            {/* Not Start - สีเทา */}
            {(dataOverview.percent_notstart || 0) > 0 && (
              <circle
                cx="80"
                cy="80"
                r="70"
                fill="none"
                stroke="#667085"
                strokeWidth="18"
                strokeDasharray={`${
                  ((dataOverview.percent_notstart || 0) / 100) * 439.8 - 4
                } ${439.8 - ((dataOverview.percent_notstart || 0) / 100) * 439.8 + 4}`}
                strokeDashoffset="0"
              />
            )}
            {/* On time - สีเขียว */}
            {(dataOverview.percent_ontime || 0) > 0 && (
              <circle
                cx="80"
                cy="80"
                r="70"
                fill="none"
                stroke="#22AB67"
                strokeWidth="18"
                strokeDasharray={`${
                  ((dataOverview.percent_ontime || 0) / 100) * 439.8 - 4
                } ${439.8 - ((dataOverview.percent_ontime || 0) / 100) * 439.8 + 4}`}
                strokeDashoffset={-((dataOverview.percent_notstart || 0) / 100) * 439.8}
              />
            )}
            {/* Delay - สีแดง */}
            {(dataOverview.percent_delay || 0) > 0 && (
              <circle
                cx="80"
                cy="80"
                r="70"
                fill="none"
                stroke="#D92D20"
                strokeWidth="18"
                strokeDasharray={`${
                  ((dataOverview.percent_delay || 0) / 100) * 439.8 - 4
                } ${439.8 - ((dataOverview.percent_delay || 0) / 100) * 439.8 + 4}`}
                strokeDashoffset={
                  -(
                    ((dataOverview.percent_notstart || 0) +
                      (dataOverview.percent_ontime || 0)) /
                    100
                  ) * 439.8
                }
              />
            )}
            {/* On hold - สีเทาเข้ม */}
            {(dataOverview.percent_onhold || 0) > 0 && (
              <circle
                cx="80"
                cy="80"
                r="70"
                fill="none"
                stroke="#344054"
                strokeWidth="18"
                strokeDasharray={`${
                  ((dataOverview.percent_onhold || 0) / 100) * 439.8 - 4
                } ${439.8 - ((dataOverview.percent_onhold || 0) / 100) * 439.8 + 4}`}
                strokeDashoffset={
                  -(
                    ((dataOverview.percent_notstart || 0) +
                      (dataOverview.percent_ontime || 0) +
                      (dataOverview.percent_delay || 0)) /
                    100
                  ) * 439.8
                }
              />
            )}
            {/* Complete - สีน้ำเงิน */}
            {(dataOverview.percent_complete || 0) > 0 && (
              <circle
                cx="80"
                cy="80"
                r="70"
                fill="none"
                stroke="#074E9F"
                strokeWidth="18"
                strokeDasharray={`${
                  ((dataOverview.percent_complete || 0) / 100) * 439.8 - 4
                } ${439.8 - ((dataOverview.percent_complete || 0) / 100) * 439.8 + 4}`}
                strokeDashoffset={
                  -(
                    ((dataOverview.percent_notstart || 0) +
                      (dataOverview.percent_ontime || 0) +
                      (dataOverview.percent_delay || 0) +
                      (dataOverview.percent_onhold || 0)) /
                    100
                  ) * 439.8
                }
              />
            )}
          </svg>
        </div>

        <div className="percent-success">
          <h1>{dataOverview.percent_complete || 0}%</h1>
          <p>Completed</p>
        </div>
      </div>

      <div className="statusOverview">
        <div className="status-row-1">
          <div className="status-not-start">
            <h5>Not start</h5>
            <h1>{dataOverview['Not Start'] || 0}</h1>
          </div>
          <div className="status-on-time">
            <h5>On time</h5>
            <h1 className="font-context">{dataOverview['On time'] || 0}</h1>
          </div>
          <div className="status-empty">
            <h5>&nbsp;</h5>
            <h1>&nbsp;</h1>
          </div>
        </div>
        <div className="status-row-2">
          <div className="status-delay">
            <h5>Delay</h5>
            <h1 className="font-context">{dataOverview['Delay'] || 0}</h1>
          </div>
          <div className="status-on-hold">
            <h5>On hold</h5>
            <h1 className="font-context">{dataOverview['On hold'] || 0}</h1>
          </div>
          <div className="status-complete">
            <h5 className="font-title">Complete</h5>
            <h1 className="font-context">{dataOverview['Complete'] || 0}</h1>
          </div>
        </div>
      </div>
    </TaskOverview>
  )
}

export default TaskCircleprogress
